import BulkItem from './BulkItem';

export default class WorkQueue extends BulkItem {
    workQueueId: string;
    workQueueName: string;
    workQueueType: string;
    order: number;
    slaTargetDuration: number;
    slaTargetInTimeRangeTimeUnit: string; //"SECONDS"
    slaTargetInTimeRangeDuration: number;
    slaTargetPercentage: number;

    constructor(
        workQueueId: string,
        workQueueName: string,
        workQueueType: string,
        order: number,
        slaTargetDuration: number,
        slaTargetInTimeRangeTimeUnit: string,
        slaTargetInTimeRangeDuration: number,
        slaTargetPercentage: number
    ) {
        super(workQueueId, workQueueName);

        this.workQueueId = workQueueId;
        this.workQueueName = workQueueName;
        this.workQueueType = workQueueType;
        this.order = order;
        this.slaTargetDuration = slaTargetDuration;
        this.slaTargetInTimeRangeTimeUnit = slaTargetInTimeRangeTimeUnit;
        this.slaTargetInTimeRangeDuration = slaTargetInTimeRangeDuration;
        this.slaTargetPercentage = slaTargetPercentage;
    }

    public static fromObject(object: any) {
        const allProps = ['workQueueId', 'workQueueName', 'workQueueType'].every(prop => object.hasOwnProperty(prop));

        if (allProps) {
            return new WorkQueue(
                object.workQueueId,
                object.workQueueName,
                object.workQueueType,
                object.order,
                object.slaTargetDuration,
                object.slaTargetInTimeRangeTimeUnit,
                object.slaTargetInTimeRangeDuration,
                object.slaTargetPercentage,
            );
        }

        return null;
    }

    toString() {
        if (this.workQueueName) {
            return this.workQueueName;
        }

        return this.workQueueId;
    }

    get sortValue() {
        return this.order ? this.order : this.toString();
    }
}

